<template>
  <div>
    <div class="widget mercado-widget categories-widget">
      <span class="widget-title" v-if="!name">{{ cleanSlug(this.$route.params.name) }}</span>
      <span class="widget-title" v-if="name" style="line-height: 20px">{{ this.name }}</span>
      <div class="widget-content">
        <ul class="list-category">
          <li v-for="(sub, index) in this.itemsFiltro" :class="['category-item has-child-cate widget filter-widget open']" :key="index">
            <template v-if="sub.Tipo != 'I' || sub.Valores.length > 0">
              <span class="widget-title" v-if="sub.Grupo && (parseInt(sub.Grupo[0], 10) & 1) != 0">{{ sub.Grupo.substring(2) }}</span>
              <a rel="nofollow" href="#" :class="['cate-link', sub.QtdeProdutos + sub.QtdeFalso > 0 ? '' : 'inactive']">
                <i v-if="sub.Grupo" class="fa fa-caret-right m10"></i> {{ sub.Descricao }} <small>({{ sub.QtdeProdutos + sub.QtdeFalso }})</small
                ><i v-show="(sub.FlagFiltro & 8) != 0" class="fa fa-check m10" aria-hidden="true"></i>
                <span class="toggle-control pull-right">+</span>
              </a>

              <template v-if="sub.Tipo == 'I'">
                <ul class="m10 sub-cate vertical-list">
                  <li class="category-item" v-for="atrib in sub.Valores" :key="atrib.Id">
                    <a
                      v-bind:data_type="sub.Tipo"
                      v-bind:href="$route.path"
                      rel="nofollow"
                      v-bind:data_id="atrib.Id"
                      v-bind:data_atrib_id="sub.Id"
                      @click.prevent="filter($event, sub, atrib)"
                      :class="['filter-link', (atrib.FlagFiltro & 4) != 0 ? 'active' : '', atrib.QtdeProdutos == 0 ? 'inactive' : '']"
                      >{{ atrib.Descricao }}</a
                    ><small :class="['filter-link', (atrib.FlagFiltro & 4) != 0 ? 'active' : '', atrib.QtdeProdutos == 0 ? 'inactive' : '']">
                      ({{ atrib.QtdeProdutos }})</small
                    >
                  </li>
                </ul>
              </template>
              <FilterLeft v-else-if="sub.Tipo == 'N'" v-bind:filtro="sub" v-bind:callBack="filterRange"></FilterLeft>
              <template v-else>
                <ul class="m10 sub-cate vertical-list">
                  <li class="category-item" :key="sub.id + '_1'">
                    <a
                      :class="['filter-link', sub.QtdeProdutos == 0 ? 'inactive' : '']"
                      v-bind:data_type="sub.Tipo"
                      data_b="1"
                      v-bind:data_id="sub.Id"
                      v-bind:href="$route.path"
                      rel="nofollow"
                      @click.prevent="filterYesNo($event, sub)"
                      >Sim</a
                    ><small :class="['filter-link', sub.QtdeProdutos == 0 ? 'inactive' : '']"> ({{ sub.QtdeProdutos }})</small>
                  </li>
                  <li class="category-item" :key="sub.id + '_0'">
                    <a
                      :class="['filter-link', sub.QtdeFalso == 0 ? 'inactive' : '']"
                      vif="sub.QtdeFalso != 0"
                      v-bind:data_type="sub.Tipo"
                      v-bind:data_id="sub.Id"
                      v-bind:href="$route.path"
                      rel="nofollow"
                      data_b="0"
                      @click.prevent="filterYesNo($event, sub)"
                      >Não</a
                    ><small :class="['filter-link', sub.QtdeFalso == 0 ? 'inactive' : '']"> ({{ sub.QtdeFalso }})</small>
                  </li>
                </ul>
              </template>
            </template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import FilterLeft from './product-list/FilterLeft.vue'

export default {
  name: 'ProductFilters',
  props: ['category', 'brands', 'name', 'itemsFiltro'],
  components: { FilterLeft },
  mounted() {
    this.getFilters()
  },
  data() {
    return {
      filtro: {
        aldo: false,
        obj: {},
        query: '',
        idAcionado: null,
        termo: '',
        filtroAtributos: '',
        filterId: null,
      },
    }
  },
  methods: {
    removeParam(key, sourceURL) {
      var rtn = sourceURL.split('?')[0],
        param,
        params_arr = [],
        queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : ''
      if (queryString !== '') {
        params_arr = queryString.split('&')
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split('=')[0]
          if (param === key) {
            params_arr.splice(i, 1)
          }
        }
        rtn = rtn + '?' + params_arr.join('&')
      }
      return rtn
    },
    getFilters() {
      var slug = this.$route.params.pathMatch !== undefined ? this.$route.params.name + this.$route.params.pathMatch : this.$route.params.name

      let remove = false

      this.itemsFiltro.forEach((element) => {
        if (element.Valores != null) {
          let valores = element.Valores

          let valor = valores.filter((c) => (c.FlagFiltro & 4) != 0)

          if (valor.length == 0) {
            remove = true
            return
          }
        }
      })

      if (this.filtro.query) {
        window.history.pushState('', '', `?filtro=${this.filtro.query}`)
      } else if (remove) {
        let urlRemoved = this.removeParam('filtro', location.href)
        window.history.pushState('', '', urlRemoved)
      }

      this.$parent.clearOffSet()
      this.$parent.loadProducts()
    },
    SearchProdutos: function () {
      var slug = this.$route.params.pathMatch !== undefined ? this.$route.params.name + this.$route.params.pathMatch : this.$route.params.name

      let self = this
      self.filtro.query = ''

      $('.categories-widget')
        .find('a.active')
        .each(function (a, b) {
          let l_data_type = $(b).attr('data_type')
          let l_query = self.filtro.query
          let l_data_id

          if (l_data_type != 'N') {
            if ((l_data_id = $(b).attr('data_id')) != undefined) {
              if (l_query != '') {
                l_query += ';'
              }

              l_query += l_data_id

              if (l_data_type == 'B') {
                l_query += ':' + $(b).attr('data_b')
              }
            }
          }
          self.filtro.query = l_query
        })

      $('.price-filter').each(function (a, b) {
        let b$ = $(b)

        let id = b$.attr('data_id')
        let lb = b$.find('#slider_range_lb_' + id)
        let ub = b$.find('#slider_range_ub_' + id)

        let sub = self.itemsFiltro.filter((c) => c.Id == id)[0]

        if ((sub.FlagFiltro & 4) != 0) {
          if (self.filtro.query) self.filtro.query += ';'
          self.filtro.query += id + ':' + lb.val() + '~' + ub.val()
        }
      })

      this.getFilters()
    },
    filter: function (ev, sub, atrib) {
      this.filtro.idAcionado = sub.Id

      localStorage.idAcionado = this.filtro.idAcionado

      let _tgt = jQuery(ev.target)
      if (_tgt.hasClass('active')) {
        _tgt.removeClass('active')
        ;(atrib || sub).FlagFiltro &= -5
      } else {
        _tgt.addClass('active')
        ;(atrib || sub).FlagFiltro |= 4
      }

      this.SearchProdutos()
    },
    filterRange: function (ev, sub, applyFlag) {
      this.filtro.idAcionado = sub.Id

      localStorage.idAcionado = this.filtro.idAcionado

      let _tgt = jQuery(ev.target)
      if (applyFlag == 1) {
        if (!_tgt.hasClass('active')) _tgt.addClass('active')
        sub.FlagFiltro |= 4
      } else if (applyFlag == 0) {
        _tgt.removeClass('active')
        sub.FlagFiltro &= -5
      }

      this.SearchProdutos()
    },
    filterYesNo: function (ev, sub) {
      this.filtro.idAcionado = sub.Id

      localStorage.idAcionado = this.filtro.idAcionado
      var _this = ev.target
      var aqtual = jQuery(_this).hasClass('active')
      $(_this).parents('ul.vertical-list').find('a').removeClass('active')
      if (jQuery(_this).hasClass('active') || aqtual) {
        jQuery(_this).removeClass('active')
      } else {
        jQuery(_this).addClass('active')
      }

      this.SearchProdutos()
    },
    cleanSlug: function (value) {
      return value.toString().replace('-', ' ')
    },
  },
}
</script>
